import axios from "axios";

export const apiCaller = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});